/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Paper,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    TableCell,
    TableBody,
    Button,
    Grid,
    TextField,
    Stack
} from '@mui/material';
// import { makeStyles } from '@mui/styles';
import TablePagination from '@mui/material/TablePagination';
import router from 'routes/router';
import fetchClient from 'views/utilities/RestfulAPI';
import SearchIcon from '@mui/icons-material/Search';
import DialogUtil from 'ui-component/show_confirm_action';
import { makeStyles } from '@mui/styles';
import { Close } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Loading from 'ui-component/Loading';
import { getRoleButton } from 'utils/roleUility';
import NotFound from 'ui-component/404/404';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    tableRow: {
        height: 30,
        '&:hover': {
            backgroundColor: '#a9f1fc !important'
        },
        [theme.breakpoints.down('md')]: {
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }
    },
    tableCell: {
        padding: '8px'
    }
}));

const style = {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: { md: '45%', xs: '98%' },
    bgcolor: 'background.paper',
    outline: 'none',
    boxShadow: 24,
    p: 2
};

// const useStyles = makeStyles({
//     table: {
//         minWidth: 600,
//         '& .MuiTableCell-root': {
//             borderLeft: '1px solid rgba(224, 224, 224, 1)',
//             borderTop: '1px solid rgba(224, 224, 224, 1)',
//             borderRight: '1px solid rgba(224, 224, 224, 1)'
//         }
//     },
//     tableRowRoot: {
//         '&$tableRowSelected, &$tableRowSelected:hover': {
//             backgroundColor: 'white'
//         }
//     },
//     tableRowSelected: {
//         backgroundColor: 'green'
//     }
// });

const ModalListWork = ({ show, handleClose, onSelected, member }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const customization = useSelector((state) => state.customization);
    const classes = useStyles();
    const [dataList, setDataList] = useState([]);
    const [idChoose, setIdChoose] = useState('');
    const [nameChoose, setNameChoose] = useState('');
    const [nameSearch, setNameSearch] = useState('');
    const [dataChoose, setDataChoose] = useState({});
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [total, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const dataGenry = JSON.parse(localStorage.getItem('m_genre'));
    const getList = async () => {
        setLoading(true);
        const obj = {
            rowsPerpage: rowsPerPage,
            currentPage: page
        };

        const response = await fetchClient.postRequest(router.SUB_URL.list_works, obj);
        if (response?.status === 201) {
            setTotalRows(response?.data?.total);
            setDataList(response?.data?.original || []);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show === true) {
            getList();
        }
    }, [show, rowsPerPage, page]);

    const columns = [
        { id: 'stt', label: 'STT', minWidth: 70, align: 'center', rowAlign: 'center', xsDisplay: 'none' },
        {
            id: 'work_name',
            label: 'Tên tác phẩm',
            width: 170,
            align: 'center',
            rowAlign: 'center',
            color: 'black',
            sx: { position: 'sticky', left: '0px', zIndex: '99', borderRight: { md: 'none', xs: '1px solid white' } }
        },
        { id: 'type', label: 'Thể loại', width: 150, align: 'center', rowAlign: 'center', color: 'black' },
        { id: 'content', label: 'Nội dung', width: 150, align: 'center', rowAlign: 'center', color: 'black' }
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const onClickRow = (value) => {
        // eslint-disable-next-line no-underscore-dangle
        // console.log('value ', value);
        // setNameChoose(value.name_work);
        setIdChoose(value._id);
        setDataChoose(value);
    };

    const onCloseModal = () => {
        setIdChoose('');
        setNameChoose('');
        setNameSearch('');
        setDataChoose({});
        setPage(0);
        setRowsPerPage(10);
        setTotalRows(0);
        setDataList([]);
        handleClose();
    };

    const onSave = async () => {
        // console.log('id child ', idChoose);
        // const objSave = {
        //     id: idChoose,
        //     name: nameChoose
        // };
        onSelected(dataChoose);
        setDataChoose({});
        setIdChoose('');
        setNameChoose('');
        setNameSearch('');
        setPage(0);
        setRowsPerPage(10);
        setTotalRows(0);
        setDataList([]);
        handleClose();
    };

    const onChangeInput = (e) => {
        setNameSearch(e.target.value);
    };

    const onSearch = async () => {
        const obj = {
            search: nameSearch,
            rowsPerpage: rowsPerPage,
            currentPage: page
        };

        const response = await fetchClient.postRequest(router.SUB_URL.list_works, obj);
        setPage(0);
        setRowsPerPage(10);
        setTotalRows(response?.data?.total);
        setDataList(response?.data?.original || []);
        setIdChoose('');
        setNameChoose('');
    };
    useEffect(() => {
        if (nameSearch !== null) {
            const delayDebounceFn = setTimeout(async () => {
                onSearch();
            }, 1000);
            return () => clearTimeout(delayDebounceFn);
        }
        return null;
    }, [nameSearch]);

    const findName = (value) => {
        const rst = dataGenry
            ?.filter((r) => {
                return r?.config_value.genre_id === value;
            })
            .map((m) => {
                return m?.config_value.genre_name;
            });
        return rst;
    };

    return (
        <>
            <Modal
                open={show}
                onClose={() => onCloseModal()}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={style} fullWidth>
                    <Typography id="modal-modal-title" variant="h3" component="h2">
                        Danh sách tác phẩm
                    </Typography>
                    <div>
                        <Grid container spacing={1} sx={{ flexDirection: 'row', marginTop: 2 }}>
                            <Grid item md={10} xs={10}>
                                <TextField
                                    label="Tìm kiếm..."
                                    fullWidth
                                    value={nameSearch}
                                    onChange={onChangeInput}
                                    sx={{ height: 5, marginRight: 1 }}
                                    placeholder="Nhập tên cần tìm..."
                                />
                            </Grid>
                            {/* <Grid item md={2} xs={2}> */}
                            {/* <Button sx={{ height: 50 }} aria-label="add" variant="outlined" size="small" onClick={() => onSearch()}>
                                <SearchIcon />
                            </Button>
                            <IconButton type="submit" onClick={() => onSearch()}>
                                <SearchIcon style={{ fill: 'blue' }} />
                            </IconButton> */}
                            {/* </Grid>  */}
                        </Grid>
                        <Stack spacing={1}>
                            <Paper>
                                {dataList?.length > 0 ? (
                                    <TableContainer
                                        sx={{
                                            maxHeight: 440,
                                            position: 'relative',
                                            marginTop: '50px',
                                            '&::-webkit-scrollbar': {
                                                width: { md: '0.4em', xs: '3px' },
                                                height: { md: '5px', xs: '3px' }
                                            },
                                            '&::-webkit-scrollbar-track': {
                                                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
                                            },
                                            '&::-webkit-scrollbar-thumb': {
                                                backgroundColor: customization?.themeDongHo?.heading,
                                                outline: 'slategrey'
                                            }
                                        }}
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map(
                                                        (column) =>
                                                            ((!isMobile && column.mdDisplay !== 'none') ||
                                                                (isMobile && column.xsDisplay !== 'none')) && (
                                                                <TableCell
                                                                    variant="head"
                                                                    key={column.id}
                                                                    align={column.align}
                                                                    sx={{
                                                                        top: 1,
                                                                        minWidth: column.width,
                                                                        color: column.color,
                                                                        ...column.sx
                                                                    }}
                                                                >
                                                                    {column.label}
                                                                </TableCell>
                                                            )
                                                    )}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {dataList.map((row, index) => (
                                                    <TableRow
                                                        //  member === row.id ? 'black' : idChoose === row._id ? '' :
                                                        onClick={() => onClickRow(row)}
                                                        hover
                                                        className={!isMobile && classes.tableRow}
                                                        role="checkbox"
                                                        key={row._id}
                                                        tabIndex={-1}
                                                        style={{
                                                            height: 5,
                                                            // eslint-disable-next-line no-underscore-dangle
                                                            backgroundColor: idChoose === row._id ? '#b3c7e8' : '#f0f0f0'
                                                        }}
                                                    >
                                                        {!isMobile && (
                                                            <TableCell style={{ height: 'auto !important' }} align="center">
                                                                {index + 1 + page * (rowsPerPage - 0)}
                                                            </TableCell>
                                                        )}
                                                        <TableCell
                                                            sx={{
                                                                height: 'auto !important',
                                                                position: { md: 'relative', xs: 'sticky' },
                                                                left: '0px',
                                                                zIndex: '9',
                                                                ...(isMobile && {
                                                                    backgroundColor: idChoose === row._id ? '#b3c7e8' : '#f0f0f0'
                                                                })
                                                            }}
                                                            align="left"
                                                        >
                                                            {row?.name_work}
                                                        </TableCell>
                                                        <TableCell style={{ height: 'auto !important' }} align="center">
                                                            {row?.type ? row?.type.flatMap((m) => findName(m)).join(', ') : ''}
                                                        </TableCell>
                                                        <TableCell style={{ height: 'auto !important' }} align="center">
                                                            {row?.content}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <NotFound />
                                )}
                                <TablePagination
                                    sx={{
                                        overflowX: 'hidden',
                                        '.MuiInputBase-root': {
                                            marginRight: { xs: '10px', sm: '32px' }
                                        },
                                        '.MuiToolbar-root': {
                                            paddingLeft: '0px !important'
                                        },
                                        '.MuiTablePagination-actions': {
                                            marginLeft: { xs: '0px !important', sm: '20px !important' }
                                        }
                                    }}
                                    labelRowsPerPage="Phân trang"
                                    // rowsPerPageOptions={[10, 20, 30]}
                                    component="div"
                                    count={total}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    showFirstButton
                                    showLastButton
                                />
                            </Paper>
                        </Stack>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginBottom: 10, marginTop: 10 }}>
                        {/* <div style={{ marginRight: 2 }}>
                            <SplitButton dataOptions={dataOptions} handleItemClick={(event) => actionAddChild(event.key)} />
                        </div> */}
                        {/* {(role?.create || role?.update) && ( */}
                        <Button
                            disabled={idChoose === '' || idChoose === member}
                            onClick={onSave}
                            color="primary"
                            variant="contained"
                            style={{ marginRight: 5, borderBlockColor: 'black' }}
                            startIcon={<SaveIcon />}
                        >
                            Chọn
                        </Button>
                        {/* )} */}
                        <Button
                            color="primary"
                            variant="contained"
                            className="mr-2"
                            style={{ marginRight: 5, borderBlockColor: 'black' }}
                            onClick={onCloseModal}
                            startIcon={<Close />}
                        >
                            Đóng
                        </Button>
                    </div>
                </Box>
            </Modal>
            <Loading show={loading}></Loading>
        </>
    );
};
export default ModalListWork;
